import * as React from 'react';
import { classNames } from '../../utils/utils';
import { ShuttleContext } from './ShuttleContext';
import { NUMBER_OF_CONTAINERS, SHUTTLE_CONTAINERS_ARRAY } from './globals';
let id_int = 0; // eslint-disable-line @typescript-eslint/camelcase
/**
 * Pass a child render function or a render prop.
 */
export const ShuttleContainer = React.memo(
// eslint-disable-next-line react/display-name
React.forwardRef(({ children, className, ...rest }, ref) => {
    const { shuttleState } = React.useContext(ShuttleContext);
    // mod needed for HMR updates
    const id = React.useRef(SHUTTLE_CONTAINERS_ARRAY[Math.floor(id_int++ % NUMBER_OF_CONTAINERS)] // eslint-disable-line @typescript-eslint/camelcase
    );
    /**
     * Pass the props to the item as you render it.
     * This is important to include since it contains
     * optimizations for click events on the shuttle
     * item.
     */
    const getItemProps = React.useCallback((index) => {
        return {
            'data-index': index,
            selected: shuttleState.selected[id.current].has(index),
        };
    }, [shuttleState]);
    return (React.createElement("div", Object.assign({ className: classNames('shuttle__container', className), role: "listbox" }, rest, { "data-name": id.current, ref: ref, tabIndex: 0 }), children(shuttleState, getItemProps)));
}));
ShuttleContainer.displayName = 'Shuttle.Container';
